import React from 'react';
import { useTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button, Link } from 'formlabs-web-components/Link';

import LeadTime from './LeadTime';
import Price from './Price';

import './BundleProduct.module.css';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/400x400`;

const BundleProduct = ({ baseUrl, product, manualEntry }) => {
  const { attributes, classes, media, name, price, url } = product;

  const [t] = useTranslation();

  const to = `${baseUrl}${url}/`;
  const image =
    media && media.length
      ? media.filter(item => item.media_type === 'image')[0].file
      : attributes.image;
  const imageSrc = manualEntry ? image : `${cdnUrl}${image}`;

  return (
    <section className={classes} styleName="product">
      <div styleName="image">
        <Link to={to}>
          <img src={imageSrc} alt={name} />
        </Link>
      </div>
      <div styleName="body">
        <div styleName="name">
          {manualEntry ? name : <Link to={to}>{name}</Link>}
        </div>
        <Price styleName="price" price={price} isMinPrice={!manualEntry} />
        {product.specialContent ? (
          <div styleName="description">{product.specialContent}</div>
        ) : (
          <div
            styleName="description"
            dangerouslySetInnerHTML={{ __html: attributes.description }}
          />
        )}
      </div>
      {attributes.leadTime && attributes.leadTime > 0 ? (
        <LeadTime styleName="lead-time" value={attributes.leadTime} />
      ) : null}
      <div styleName="action">
        {manualEntry ? product.cta : <Button to={to}>{t('Select')}</Button>}
      </div>
    </section>
  );
};

export default DisplayComponent(BundleProduct);
